import { render, staticRenderFns } from "./main-visitant.vue?vue&type=template&id=856f3c56&scoped=true&"
import script from "./main-visitant.vue?vue&type=script&lang=js&"
export * from "./main-visitant.vue?vue&type=script&lang=js&"
import style0 from "./main-visitant.vue?vue&type=style&index=0&id=856f3c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f3c56",
  null
  
)

export default component.exports